import { connect } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { Route } from 'react-router-dom';
import styled from 'react-emotion';

import { ALERT_BANNERS } from './constants/alertBanners';
import AlertBanner from './components/AlertBanner/AlertBanner';
import Auth from './views/Auth/Auth';
import beakerIcon from './assets/images/icons/beaker.svg';
import Browse from './views/Browse/Browse';
import CreateEvent from './views/CreateEvent/CreateEvent';
import Detail from './views/Detail/Detail';
import history from './redux/store/history';
import ManageEvents from './views/ManageEvents/ManageEvents';
import Masthead from './views/Masthead/Masthead';
import SignUpSuccess from './views/SignUpSuccess/SignUpSuccess';
import Style from './styles/common';
import UserVerified from './views/UserVerified/UserVerified';

const Main = styled('main')`
  background-color: ${Style.color.contentBackground};
  min-height: 100%;
  padding-top: ${Style.MEASUREMENT.MASTHEAD.HEIGHT}px;
`;

function Routes(props) {
  return (
    <ConnectedRouter history={history}>
      <Main>
        <AlertBanner
          banner={ALERT_BANNERS.BETA}
          icon={beakerIcon}
          message="All These Events is currently in beta and includes event listing for promotional purposes"
        />
        <Masthead />
        <Route path="/auth" component={Auth} />
        <Route exact path="/" component={Browse} />
        <Route path="/event/:id" component={Detail} />
        <Route path="/create-event" component={CreateEvent} />
        <Route path="/manage-events" component={ManageEvents} />
        <Route path="/user-verified" component={UserVerified} />
        <Route path="/sign-up-success" component={SignUpSuccess} />
      </Main>
    </ConnectedRouter>
  );
}

Routes.propTypes = {
  isBannerVisible: PropTypes.bool,
};

Routes.defaultProps = {
  isBannerVisible: false,
};

export default connect(
  state => ({
    isBannerVisible: state.alertBanner[ALERT_BANNERS.BETA],
  })
)(Routes);



// WEBPACK FOOTER //
// ./src/Routes.js